import { useTranslation } from "react-i18next";

function useLanguageSelector() {
  const { t, i18n } = useTranslation();

  function setLocalStorageLanguage(language: string) {
    localStorage.setItem("lang", language);
  }

  function changeLanguage(language: string) {
    i18n.changeLanguage(language);
  }

  function handleLoginLanguage(language: string) {
    setLocalStorageLanguage(language);
    changeLanguage(language);
  }

  const inputLanguageOptions = [
    { id: "1", value: "en-US", label: "🇺🇸 " + t("englishUS") },
    { id: "2", value: "es-ES", label: "🇪🇸 " + t("spanishES") },
    { id: "3", value: "fr-CA", label: "🇫🇷 " + t("frenchCA") },
  ];

  return {
    inputLanguageOptions,
    handleLoginLanguage,
  };
}

export default useLanguageSelector;
